import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/make-booking/$id/payment')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
